import { computed, Injectable, signal } from '@angular/core';
import { jwtDecode } from 'jwt-decode';


@Injectable({
  providedIn: 'root'
})
export class TokenTimerService {
  private remainingTime = signal<number>(0);

  exp: any;
  expirationTime: any;
  remaining: any;

  constructor() {    
    this.startTime();
  }

  private startTime(): void {
    const token = this.getToken();
    if(!token) {
      this.remainingTime.set(0);
      return;
    }
    
    const decoded = jwtDecode(token);
    this.exp = decoded.exp;
    this.expirationTime = this.exp! * 1000;    
    
    this.timer();
    this.remainingTime.set(Math.max(this.remaining, 0));

    const timer = setInterval(() => {
      this.timer();
      this.remainingTime.set(Math.max(this.remaining, 0));
      if (this.remaining <= 0) clearInterval(timer);
    }, 60 * 1000);
  }
  
  private getToken() {
    return localStorage.getItem('access_token');
  }

  private timer() {      
      const now = Date.now();
      this.remaining = this.expirationTime - now;
  }
  
  getMainingTime = computed(() => {
    const ms = this.remainingTime();
    const minutes = Math.floor(ms / (60 * 1000));
    return minutes;
  });

}
